import React, { Component } from "react";

import UI from "../../../../actions/ui-helper";

class AuditoriaProcedimentoValor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filtroUsuario: 1, // 0 - TODOS, 1 - ATIVOS, 2 - INATIVOS
    };

    this.handleChange = this.handleChange.bind(this);
  }

  componentDidUpdate() {
    UI.dataTable("#data-table");
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  render() {
    let styleContraste = {
      border: "1px dashed #777",
      fontWeight: "700",
      background: "#fff"
    }

    if (this.props.valores.length === 0) return false;
    //let filtroUsuario = parseInt(this.state.filtroUsuario);

    return (
      <div className="col-md-12 grid-margin">
        <div className="card">
          <div className="card-body">
            <div className="form-group row">
              <div className="col-md-10">
                <h4 className="card-title">PROFISSIONAIS VINCULADOS</h4>
              </div>
            </div>
            {this.props.valores.length > 0 &&
              <div className="form-group row">
                <div className="col-md-12 table-responsive">
                  <table id="data-table" className="table">
                    <thead>
                      <tr>
                        <th></th>
                        <th style={{ width: "50%" }}>Nome</th>
                        <th>Unidade Pagamento</th>
                        <th>Valor Pagar (R$)</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.props.valores.map(
                        function (valor, i) {
                          return (
                            <tr key={valor.usuarioId}>
                              <td>
                                <i className="icon icon-user" />
                              </td>
                              <td>{valor.usuarioNome}</td>
                              <td>
                                <select
                                  style={styleContraste}
                                  disabled
                                  name="unidade"
                                  className="form-control"
                                  value={valor.unidade}
                                >
                                  <option value={1}>HORA</option>
                                  <option value={2}>LANÇAMENTO</option>
                                </select>
                              </td>
                              <td>
                                <input
                                  style={styleContraste}
                                  disabled
                                  name="valorPagar"
                                  type="number"
                                  step="any"
                                  className="form-control"
                                  value={valor.valorPagar}
                                />
                              </td>
                              <td className="text-right">
                                <button
                                  disabled
                                  type="button"
                                  onClick={() => {
                                    this.props.onRemoverValor(i);
                                  }}
                                  className="btn btn-remove icon-btn"
                                >
                                  <i className="fa fa-times"></i>
                                </button>
                              </td>
                            </tr>
                          );
                        }.bind(this)
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    );
  }
}

export default AuditoriaProcedimentoValor;
